import { Component, OnInit, Input, ApplicationRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PropertiesService } from '../properties.service';

export enum DeviceType {
  IPHONE = 1,
  ANDROID_PHONE = 2,
  TABLET = 3,
  LAPTOP = 4
}

@Component({
  selector: 'app-website-preview',
  templateUrl: './website-preview.component.html',
  styleUrls: ['./website-preview.component.scss']
})
export class WebsitePreviewComponent implements OnInit {
  @Input('url') url: string;
  @Input('device') device: DeviceType = DeviceType.LAPTOP;
  public deviceType = DeviceType;

  private websiteUrl: SafeResourceUrl;
  constructor(private app: ApplicationRef, private sanitizer: DomSanitizer, private properties: PropertiesService) {
    this.properties.currentMessage.subscribe(message => {
      console.log('Checking message', message);
      if (message === "reload-preview") {
        this.url = this.url + '?dummy=' + (new Date()).getTime();
        this.websiteUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://" + this.url.replace('(dot)', '.'));
        this.app.tick();
      }
    });
  }

  ngOnInit() {
    if (this.url) {
      this.websiteUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://" + this.url.replace('(dot)', '.'));
    }
    
  }

}
